module.exports = __webpack_public_path__ + "img/novelthree.6446d8f9.png";